import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ConnectableObservable, Observable } from "rxjs";
import { publishLast } from "rxjs/operators";

import { withSpinner } from "../../extensions/withSpinner.extension";
import { API_ROOT } from "../../types/constants/appconstants";
import { Contact } from "../../types/contact";
import { User } from "../../types/user";

@Injectable({
    "providedIn": "root"
})
export class ContactService {
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private contactServiceBaseUrl = this.apiRoot + "api/contacts";

    private lastEndDate_getApprovers: Date;
    private lastEndDate_getIssuers: Date;
    private lastEndDate_getVoiders: Date;
    private lastMarketId_getApprovers: number;
    private lastMarketId_getIssuers: number;
    private lastMarketId_getVoiders: number;
    private lastStartDate_getApprovers: Date;
    private lastStartDate_getIssuers: Date;
    private lastStartDate_getVoiders: Date;    
    private approversObs: ConnectableObservable<User[]>;    
    private issuersObs: ConnectableObservable<User[]>;    
    private voidersObs: ConnectableObservable<User[]>;

    getPurchaseOrderApprovers(marketId: number, startDate: Date, endDate: Date): Observable<User[]> {
        if (this.lastMarketId_getApprovers !== marketId || this.lastStartDate_getApprovers !== startDate || this.lastEndDate_getApprovers !== endDate) {
            this.approversObs = withSpinner(this.http, "Loading Purchase Order Approvers...").post<User[]>(this.contactServiceBaseUrl + "/approvers", { "marketId": marketId, "startDate": startDate, "endDate": endDate }).pipe(
                publishLast()
            ) as ConnectableObservable<User[]>;
            this.approversObs.connect();

            this.lastMarketId_getApprovers = marketId;
            this.lastStartDate_getApprovers = startDate;
            this.lastEndDate_getApprovers = endDate;
        }

        return this.approversObs;
    }

    getPurchaseOrderIssuers(marketId: number, startDate: Date, endDate: Date): Observable<User[]> {
        if (this.lastMarketId_getIssuers !== marketId || this.lastStartDate_getIssuers !== startDate || this.lastEndDate_getIssuers !== endDate) {
            this.issuersObs = withSpinner(this.http, "Loading Purchase Order Issuers...").post<User[]>(this.contactServiceBaseUrl + "/issuers", { "marketId": marketId, "startDate": startDate, "endDate": endDate }).pipe(
                publishLast()
            ) as ConnectableObservable<User[]>;
            this.issuersObs.connect();

            this.lastMarketId_getIssuers = marketId;
            this.lastStartDate_getIssuers = startDate;
            this.lastEndDate_getIssuers = endDate;
        }

        return this.issuersObs;
    }

    getPurchaseOrderVoiders(marketId: number, startDate: Date, endDate: Date): Observable<User[]> {
        if (this.lastMarketId_getVoiders !== marketId || this.lastStartDate_getVoiders !== startDate || this.lastEndDate_getVoiders !== endDate) {
            this.voidersObs = withSpinner(this.http, "Loading Purchase Order Voiders...").post<User[]>(this.contactServiceBaseUrl + "/voiders", { "marketId": marketId, "startDate": startDate, "endDate": endDate }).pipe(
                publishLast()
            ) as ConnectableObservable<User[]>;
            this.voidersObs.connect();

            this.lastMarketId_getVoiders = marketId;
            this.lastStartDate_getVoiders = startDate;
            this.lastEndDate_getVoiders = endDate;
        }

        return this.voidersObs;
    }

    mapUserToContact(user: User): Contact {
        var contact = new Contact();
        contact.id = user.edhUserId;
        contact.azureGuid = user.azureGUID;
        contact.firstName = user.firstName;
        contact.lastName = user.lastName;
        contact.displayName = user.displayName;
        contact.emailAddress = user.emailAddress;
        contact.jobTitle = user.jobTitle;
        return contact;
    }
}
